module.exports = __webpack_public_path__ + "21a29fa96a7f0a7a13dc8c95481c664a.svg";